import { Alert, Badge, Box, Button, Checkbox, Form, FormField, Grid, Header, Select, SelectProps, SpaceBetween, SplitPanel, Steps, StepsProps, Tabs, Textarea } from '@cloudscape-design/components';
import { mdiClipboardCheck, mdiClockRemoveOutline, mdiThumbDown, mdiThumbUp, mdiTimerSettings } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { btnDanger, ItemCheck } from '../../resources/types';
import Copy from '../Copy';
import DPModal from '../DPModal';
import HorizontalRule from '../HorizontalRule';
import SelectUser from '../selects/selectUser';
import BadgeCustom from './BadgeCustom';
import ConfirmDelete from './ConfirmDelete';
import PopOverContact from './PopOverContact';
import Spacer from './Spacer';
import UserAvatar from './UserAvatar';



interface SidePanelFlightProps {
    Check: ItemCheck;
    onUpdateEval?: (updatedCheck: ItemCheck) => void;
    onUpdateCheck?: (updatedCheck: ItemCheck) => void;
    onClose?: () => void;
    editCheck?: boolean;
    editEval?: boolean;
    editIntructor?: boolean;
}

const SidePanelCheck: React.FC<SidePanelFlightProps> = ({
    Check, onUpdateEval, onUpdateCheck, onClose, editEval = false, editCheck = false, editIntructor = false
}) => {

    const { menu, idUser } = useGlobalState();

    const [isCancel, setIsCancel] = useState(false);
    const [showVoid, setShowVoid] = useState(false);
    const [cancelReason, setCancelReason] = useState("");

    const [check, setCheck] = useState<ItemCheck>(Check);
    const [checkOriginal, setCheckOriginal] = useState<ItemCheck>(Check);
    const [selectedStatusOption, setSelectedStatusOption] = useState<SelectProps.Option | null>(null);
    useEffect(() => {
        if (Check) {
            setCheck({ ...Check });
            setCheckOriginal({ ...Check });
        }
    }, [Check]);

    const handleCheckEval = (idCheckParameter: string, opt: any) => {
        if (check && checkOriginal && checkOriginal.statusRequest == 1 && check.idInstructor == idUser && editEval) {
            const updatedJsonResults = check.jsonResults.map((item: any) =>
                item.idCheckParameter === idCheckParameter
                    ? { ...item, resultValue: opt.value, resultText: opt.text }
                    : item
            );
            setCheck((prev: any) => ({
                ...prev,
                jsonResults: updatedJsonResults,
                statusRequest: prev.statusRequest === 1 ? 1 : prev.statusRequest
            }));

            // 3. Send the NEWly calculated array to the API
            // Now you aren't waiting for the state to update!
            onUpdateEval({ ...check, idRequest: check.idRequest, jsonResults: updatedJsonResults });
        }
    };
    const isValid = !(selectedStatusOption?.value === "1" ||
        (check?.jsonResults?.every(item => item.resultValue !== "") ?? false));
    const statusOptions = [
        { label: "Pendiente", value: "1", description: "Chequeo se actualiza, pero no se cierra definitivamente, puede continuar editandolo más tarde" },
        { label: "Aprobado", value: "3" },
        { label: "Aprobado *", value: "4", description: "con temas a resolver" },
        { label: "Reprobado", value: "2" },
        { label: "Anulado", value: "-1" },
        { label: "Expirado", value: "-2" },
        //{ label: "Anular", value: "-1" },
    ];
    useEffect(() => {
        if (check) {
            setSelectedStatusOption(statusOptions.find(opt => opt.value === (check?.statusRequest.toString() || "1")) || null);
        }
    }, [check]);

    const hasResult = check?.dateResult && check.dateResult !== "";

    // Helper function to map statusRequest to your string status
    type StepStatus = "success" | "error" | "warning" | "in-progress" | "pending" | "loading";
    const getStatusType = (status?: number) => {
        switch (status) {
            case 3: return "success";
            case 2: return "error";
            case -1: return "stopped";
            case -2: return "warning";
            default: return "loading";
        }
    };
    const evaluationConfig: StepsProps.Step = {
        status:
            (check?.statusRequest === 3 ? "success" :
                check?.statusRequest === 2 ? "error" :
                    check?.statusRequest === -1 ? "stopped" :
                        check?.statusRequest === -2 ? "warning" : "loading"),
        header:
            "Resultado",
        annotation:
            check?.statusRequest === 3 ? check?.dateResult :
                check?.statusRequest === 2 ? check?.dateResult :
                    check?.statusRequest === -1 ? "Anulado" :
                        check?.statusRequest === -2 ? "Expirado" : "-----",
    };

    const createStep = (date?: string, headerName?: string): StepsProps.Step => {
        const hasDate = date && date !== "";
        return {
            status: hasDate ? "success" : "loading",
            header: headerName,
            annotation: hasDate ? date : "-----"
        };
    };
    if (check) {
        return (



            <SplitPanel headerActions={<Copy value={check?.idRequest.toString()} />} header={`Solicitud`} key={"checkAssign"} hidePreferencesButton closeBehavior="hide" >
                <SpaceBetween direction="vertical" size="s">
                    <Tabs
                        key={"checkResultEval"}
                        tabs={[
                            {
                                label: "Info",
                                id: "Info",
                                content:
                                    <SpaceBetween direction="vertical" size="s">
                                        {check?.idRequestReference !== 0 && (
                                            <Alert type='warning' header="Aprobado con observaciones">
                                                Este chequeo fue aprobado con observaciones: Se genera nuevo chequeo de revisión #{check?.idRequestReference}
                                            </Alert>
                                        )}
                                        <Header variant="h3"
                                            /*description={statusCheck(check?.statusRequest || 0)}*/
                                            info={check?.statusRequest === -1 ?
                                                <Badge color="grey">Anulado</Badge> :
                                                check?.statusRequest === 0 ?
                                                    <><Icon path={mdiTimerSettings} size={1} color={"#f7c500"} /></> :

                                                    check?.statusRequest === 1 ?
                                                        <><Icon path={mdiClipboardCheck} size={1} /></> :
                                                        check?.statusRequest === 2 ?
                                                            <><Icon color="red" path={mdiThumbDown} size={1} /></> :
                                                            check?.statusRequest >= 3 ?
                                                                <><Icon color="green" path={mdiThumbUp} size={1} /></> : check?.statusRequest >= -2 ?
                                                                    <><Icon color="brown" path={mdiClockRemoveOutline} size={1} /></> : null
                                            }
                                        >
                                            {check?.check || ""}
                                        </Header>

                                        {check && check.statusRequest === -1 && (
                                            <Alert type='error' header="Motivo de anulación">{check.cancelReason == "" ? "No especificado" : check.cancelReason}</Alert>
                                        )}
                                        <SpaceBetween direction="horizontal" size="s">
                                            <UserAvatar idUser={check?.idUser || 0} />
                                            <FormField label="Piloto" >
                                                <PopOverContact idUser={check?.idUser || 0} />
                                            </FormField>
                                        </SpaceBetween>
                                        <HorizontalRule />
                                        {Number(check?.idInstructor) > 0 && (
                                            <SpaceBetween direction="horizontal" size="s">
                                                <UserAvatar idUser={check?.idInstructor || 0} />
                                                <FormField label="Instructor" >
                                                    <PopOverContact idUser={check?.idInstructor || 0} />
                                                </FormField>
                                            </SpaceBetween>
                                        )}
                                        {Number(check?.idInstructor) > 0 && (
                                            <HorizontalRule />
                                        )}
                                        {Number(check.idBooking) > 0 && check?.jsonBooking?.idBooking && (
                                            <FormField label="Reserva" info={`${check?.jsonBooking?.registration}`}>
                                                {`${check?.jsonBooking?.date} ${check?.jsonBooking?.start} - ${check?.jsonBooking?.end}`}
                                            </FormField>
                                        )}

                                        {check && (
                                            <SpaceBetween direction='vertical' size='xs' key={`assign-${check.idRequest}`}>
                                                <SpaceBetween direction='horizontal' size='xs' key={`assign-${check.idRequest}`}>
                                                    <FormField label={"Instructor"}>
                                                        <SelectUser
                                                            readonly={!((check.statusRequest === 1 || check.statusRequest === 0) && editIntructor)}
                                                            value={check?.idInstructor}
                                                            filter={`INSTRUCTOR.${check.instructorCheck}` as
                                                                | "INSTRUCTOR.GLIDER"
                                                                | "INSTRUCTOR.PLANE"
                                                                | "INSTRUCTOR.TEO"
                                                                | "INSTRUCTOR.SIM"
                                                                | "INSTRUCTOR.HELI"}
                                                            placeholder={!((check.statusRequest === 1 || check.statusRequest === 0) && editIntructor) ? check.idInstructor === 0 ? "Sin asignar" : check.instructorCheck : "Seleccione un instructor"}
                                                            onConfirm={(user) => {
                                                                if (user)
                                                                    setCheck({ ...check, idInstructor: user?.idUser, statusRequest: 1 });
                                                                else
                                                                    setCheck({ ...check, idInstructor: 0, statusRequest: 0 });
                                                            }}
                                                        />
                                                    </FormField>
                                                    {(check.statusRequest === 0 || check.statusRequest === 1) && editIntructor && (
                                                        <FormField label="&nbsp;">
                                                            <Button variant='primary'
                                                                disabled={check.idInstructor === 0}
                                                                onClick={() => {
                                                                    onUpdateCheck(check);
                                                                }}
                                                            >{check.statusRequest === 0 ? "Asignar" : "Reasignar"}</Button>
                                                        </FormField>
                                                    )}
                                                </SpaceBetween>
                                                <Spacer height={30} key={`${check?.idRequest}spacer`} />
                                                {check && (check.statusRequest === 0 || check.statusRequest === 1) && (
                                                    <Alert statusIconAriaLabel="Warning" type="warning">
                                                        <Form
                                                            secondaryActions={isCancel ? cancelReason.length < 10 ? "Max 200 cáracteres" : `${cancelReason.length}/200` : undefined}
                                                            actions={
                                                                isCancel && (
                                                                    <Button
                                                                        onClick={() => { setShowVoid(true) }}
                                                                        variant='primary' disabled={cancelReason.length < 10}>Enviar anulación</Button>
                                                                )}>
                                                            <SpaceBetween direction='vertical' size='xs'>
                                                                <Checkbox checked={isCancel} onChange={(event) => { setIsCancel(event.detail.checked) }}>Anular</Checkbox>
                                                                {isCancel && (


                                                                    <Textarea placeholder={"Motivo de anulación"} value={cancelReason} onChange={(event) => setCancelReason(event.detail.value.substring(0, 200))}>

                                                                    </Textarea>

                                                                )}

                                                                <ConfirmDelete show={showVoid} header='Anulación de chequeo'
                                                                    subtitle={`¿Realizar la anulación del chequeo #${check.idRequest}?`}
                                                                    confirmWord={'anular'} action={'Anular'} warning={'Si el chequeo ya tiene un instructor asignado, este será notificado de la anulación'}
                                                                    onDismiss={() => setShowVoid(false)} onConfirm={() => {
                                                                        const updatedCheck = {
                                                                            ...check,
                                                                            statusRequest: -1,
                                                                            cancelReason: cancelReason
                                                                        };
                                                                        onUpdateCheck(updatedCheck);
                                                                        setShowVoid(false)
                                                                    }}
                                                                />
                                                            </SpaceBetween>
                                                        </Form>
                                                    </Alert>

                                                )}
                                            </SpaceBetween>
                                        )}
                                    </SpaceBetween>
                            },
                            {
                                label: "Chequeo",
                                id: "assign",
                                content:
                                    <>
                                        {check?.statusRequest && check.statusRequest !== 1 && check.statusRequest !== 0
                                            ?
                                            <>

                                                <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
                                                    <div>
                                                        <FormField label={"Estado"}>
                                                            <Box textAlign='center'>
                                                                <SpaceBetween direction='vertical' size='xs'>
                                                                    {
                                                                        check?.statusRequest === -2 ?
                                                                            <BadgeCustom color="brown">Expirado</BadgeCustom> :
                                                                            check?.statusRequest === -1 ?
                                                                                <BadgeCustom color="grey">Anulado</BadgeCustom> :
                                                                                check?.statusRequest === 2 ?
                                                                                    <><Icon color="red" path={mdiThumbDown} size={1} /><BadgeCustom color="red">Reprobado</BadgeCustom></> :
                                                                                    <><Icon color="green" path={mdiThumbUp} size={1} /><BadgeCustom color="green">Aprobado</BadgeCustom></>
                                                                    }
                                                                </SpaceBetween>
                                                            </Box>
                                                        </FormField>
                                                    </div>
                                                    <div>
                                                        <FormField label={"Resultado"}>
                                                            {check?.statusRequest === -1 ? check.cancelReason : check?.result}
                                                        </FormField>
                                                    </div>
                                                </Grid>
                                            </>

                                            : null}

                                        <HorizontalRule />

                                        <Steps
                                            orientation="horizontal"
                                            steps={[
                                                createStep(check?.dateSubmited, "Solicitud"),
                                                createStep(check?.dateAssigned, "Asignación"),
                                                evaluationConfig
                                            ]}
                                        />




                                        <HorizontalRule />
                                        <SpaceBetween direction='vertical' size="m">
                                            {[
                                                check?.chequeo && (
                                                    <FormField label={`Chequeo ${check.check}:`} key="pchequeo">
                                                        {check.chequeo}
                                                    </FormField>
                                                ),
                                                check?.curso && (
                                                    <FormField label="Curso:" key="pcurso">
                                                        {check.curso.replace(/;;;/g, "\n")}
                                                    </FormField>
                                                ),
                                                check?.habilitacion && (
                                                    <FormField label="Habilitación:" key="phabilitacion">
                                                        {check.habilitacion.replace(/;;;/g, "\n")}
                                                    </FormField>
                                                ),
                                                check?.requisitosCondicion && (
                                                    <FormField label="Requisitos/Condición:" key="prequisitosCondicion">
                                                        {check.requisitosCondicion.replace(/;;;/g, "\n")}
                                                    </FormField>
                                                ),
                                                check?.requisitosFamiliarizacion && (
                                                    <FormField label="Requisitos/Familiarización:" key="prequisitosFamiliarizacion">
                                                        {check.requisitosFamiliarizacion.replace(/;;;/g, "\n")}
                                                    </FormField>
                                                ),
                                                check?.obsPilot && (
                                                    <FormField label="Observaciones piloto:" key="pobsPilot">
                                                        {check.obsPilot.replace(/;;;/g, "\n")}
                                                    </FormField>
                                                ),
                                                check?.obs && (
                                                    <FormField label="Observaciones:" key="pobs">
                                                        {check.obs.replace(/;;;/g, "\n")}
                                                    </FormField>
                                                ),
                                            ].filter(Boolean)}
                                        </SpaceBetween>
                                    </>
                            }, {
                                label: "Evaluación",
                                id: "result",
                                disabled: !(checkOriginal?.statusRequest && checkOriginal.statusRequest != -1 && checkOriginal.statusRequest != 0 && checkOriginal.jsonResults),
                                content:

                                    <Form actions={checkOriginal?.statusRequest === 1 && (
                                        <SpaceBetween direction="horizontal" size="xs">
                                            {editEval && (
                                                <Button disabled={isValid} variant='primary'
                                                    style={{ root: selectedStatusOption?.value === "2" ? btnDanger : null }}

                                                    onClick={() => {
                                                        // Manually merge the previous state with the new value
                                                        const updatedState = {
                                                            ...check,
                                                            statusRequest: Number(selectedStatusOption?.value),
                                                        };

                                                        // Pass the fully updated object
                                                        onUpdateCheck(updatedState);
                                                    }}
                                                >{
                                                        selectedStatusOption?.value === "-1" ? "Anular" :
                                                            selectedStatusOption?.value === "1" ? "Guardar" :
                                                                selectedStatusOption?.value === "2" ? "Reprobar" :
                                                                    "Aprobar"


                                                    }</Button>
                                            )}
                                        </SpaceBetween>

                                    )}>

                                        <SpaceBetween direction="vertical" size="xs">
                                            {check?.jsonResults.map((item) => (
                                                <FormField
                                                    key={`chkParam${item?.idCheckParameter}`}
                                                    label={item?.checkEval}
                                                /*constraintText={item.resultText}*/
                                                >
                                                    <SpaceBetween direction="horizontal" size="xs">
                                                        {item.eval.map((opt: any) => (
                                                            <div style={{ cursor: "pointer" }} onClick={() => handleCheckEval(item.idCheckParameter, opt)} key={`chkParamDiv${item?.idCheckParameter}${opt.value}`}>
                                                                <BadgeCustom size='small' bold={false}
                                                                    key={`chkParam${item?.idCheckParameter}${opt.value}`}
                                                                    color={opt.value === item.resultValue ? getColor(opt.color) : "light"}

                                                                >
                                                                    {opt.text}
                                                                </BadgeCustom>
                                                            </div>
                                                        ))}
                                                    </SpaceBetween>
                                                </FormField>
                                            ))}
                                            <FormField label="Estado del chequeo">
                                                <Select
                                                    readOnly={!editEval}
                                                    expandToViewport
                                                    selectedOption={statusOptions.find(opt => opt.value === (selectedStatusOption?.value || check?.statusRequest.toString())) || null}
                                                    onChange={({ detail }) => {
                                                        setSelectedStatusOption(detail.selectedOption)
                                                        let newCheck = check;
                                                        newCheck.statusRequest = Number(detail.selectedOption?.value)
                                                        if (Number(detail.selectedOption?.value) === 1) {
                                                            newCheck.dateResult = ""
                                                            setCheck(newCheck);
                                                        }
                                                    }}
                                                    options={statusOptions}
                                                />
                                            </FormField>
                                            {check && selectedStatusOption && Number(selectedStatusOption.value) >= 2 && (
                                                <FormField label="Fecha de evaluación"
                                                    constraintText={checkOriginal.dateResult === "" ? "Si la fecha no se especifica, se tomará la fecha actual del sistema" : ""}>
                                                    <DPModal date={check?.dateResult || ""}
                                                        end={new Date()}
                                                        readonly={!editEval}
                                                        onConfirm={(date) => {
                                                            setCheck({
                                                                ...check,
                                                                dateResult: date
                                                            });
                                                        }}
                                                    />
                                                </FormField>
                                            )}

                                            {selectedStatusOption && selectedStatusOption.value === "4" && (
                                                <Alert type='warning' header="Observaciones">
                                                    Un chequeo con estado <strong>Aprobado con Temas a Resolver</strong>, se aprobará y generará un nuevo chequeo asignado a usted como instructor. El chequeo original, se le adjuntará la glosa de Aprobado con temas a resolver además del identificador del nuevo chequeo generado por esta condición.
                                                </Alert>
                                            )}

                                            <FormField label={selectedStatusOption?.value === "-1" ? "Motivo de anulación" : "Observaciones"}
                                                constraintText={selectedStatusOption?.value === "-1" ? (<strong>* Obligatorio</strong>) : ""}
                                            >
                                                <Textarea value={check?.result || ""}
                                                    readOnly={!editEval} // || Number(check?.statusRequest) >= 2 ? true : false}
                                                    onChange={(e) => {
                                                        if (e && editEval) {
                                                            setCheck({
                                                                ...check,
                                                                result: e.detail.value
                                                            });
                                                        }
                                                    }} />
                                            </FormField>


                                        </SpaceBetween>
                                    </Form>
                            }
                        ]}
                    />
                </SpaceBetween>
            </SplitPanel >
        );
    } else {
        return null;
    }


};

export default SidePanelCheck;
function getColor(hex: string): "green" | "blue" | "red" | "grey" | "light" {
    switch (hex.toLowerCase()) {
        case "#00b000":
            return "green";
        case "#007cff":
            return "blue";
        case "#ff0000":
            return "red";
        case "#999999":
            return "grey";
        default:
            return "grey";
    }
}